import styled from 'styled-components'

export const ClinicChoosingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  padding: 20px;
  
  @media (max-width: 600px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 16px;
    
    > * {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
`

export const ClinicItem = styled.div`
  padding: 4px;
  background: transparent;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: center;
  max-width: 400px;
  border: none;
  cursor: default;
  justify-content: space-between;
  border-radius: 0;
  box-shadow: none;
  
  @media (max-width: 600px) {
    gap: 4px;
    padding: 4px;
    width: 100%;
    max-width: 100%;
  }
`
